// extracted by mini-css-extract-plugin
export default {"p":"d51248185d _73ab0c94ec _4489893b8e","clr":"_4e04e0c4d1","dls":"_9991b055a6"};